<template>
    <div>
        <div class="title">
            {{ login_txt }}
        </div>

    </div>
</template>

<script>
import { http, open_new_page } from "@/utils/http.js";
import { Base64 } from "js-base64";

export default {
    data() {
        return {
            login_txt: '大象登录中...',
            token: ''
        }
    },
    mounted() {

        var query = this.$route.query
        console.log(query)
        if (typeof (query.token) == 'string') {
            this.token = query.token
            this.login_request()
        } else {
            this.login_txt = '参数异常，登录失败'
        }
    },

    methods: {
        //登录请求
        login_request() {
            var that = this
            var obj = {
                token: this.token,
            };
            http("post", process.env.VUE_APP_HOST + "/login_dx/refreshing_login", obj, false)
                .then((res) => {
                    if (res.code == 0) {
                        that.login_txt = res.msg

                        var b64_str = Base64.decode(res.data)
                        var data = JSON.parse(b64_str)
                        that.$cookies.set(
                            "dx_token",
                            data.token,
                            data.cookie_exp,
                            '/',
                            process.env.VUE_APP_COOKIES_DOMAIN
                        );
                        that.$cookies.set(
                            "dx_private_key",
                            data.private_key,
                            data.cookie_exp,
                            '/',
                            process.env.VUE_APP_COOKIES_DOMAIN
                        );
                        that.$cookies.set(
                            "dx_public_key",
                            data.public_key,
                            data.cookie_exp,
                            '/',
                            process.env.VUE_APP_COOKIES_DOMAIN
                        );
                        that.$cookies.set(
                            "dx_user_info",
                            data.user_info,
                            data.cookie_exp,
                            '/',
                            process.env.VUE_APP_COOKIES_DOMAIN
                        );


                    } else {

                        that.login_txt = res.msg
                    }
                })
                .catch((res) => {
                    console.log(res, "请求出错");
                });


        }
    }
}
</script>

<style scoped>
.title {
    text-align: center;
    padding: 20px;
}
</style>